import AtencionActual from "./AtencionActual";
import AtencionSiguiente from "./AtencionSiguiente";
import EstadoModulo from "./EstadoModulo";
import { Card, Row, Col, Badge } from "react-bootstrap";

const styles = {
  container: {
    backgroundColor: "var(--color-background-3)",
  },
  badge: {
    marginLeft: "0.5rem",
    fontWeight: 400,
    color: "var(--color-text) !important",
  }
};

function Modulo({nombre, estado, siguiente, actual, onAtender, onFinalizar, onDescartar }) {

  return (
    <Card className="h-100 w-100 p-4 shadow-sm border" style={styles.container}>
      <Row className="mb-3">
        <Col className="d-flex align-items-center">
          <p className="h3 mb-0">{nombre}</p>
          <div style={{ marginLeft: "0.75rem" }}>
            <EstadoModulo estado={estado} />
          </div>
        </Col>
      </Row>
      <Row className="g-md-3 g-2">
        <Col md={6}>
          <AtencionActual
            actual={actual}
            onFinalizar={onFinalizar}
            onDescartar={onDescartar}
          />
        </Col>
        <Col md={6}>
          <AtencionSiguiente
            actual={actual}
            siguiente={siguiente}
            onAtender={onAtender}
          />
        </Col>
      </Row>
    </Card>
  );
}

export default Modulo;
